import * as RM from '@radix-ui/react-dropdown-menu';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils';

export const Menu = RM.Root;
export const MenuTrigger = RM.Trigger;

export const MenuContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof RM.Content>>(
  function MenuContent({ className, align = 'end', sideOffset = 6, ...props }, ref) {
    return (
      <RM.Portal>
        <RM.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'z-50 min-w-[200px] rounded-lg border border-line-2 bg-surface p-1.5 shadow-flat',
            className,
          )}
          {...props}
        />
      </RM.Portal>
    );
  },
);

export const MenuItem = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof RM.Item> & { danger?: boolean }
>(function MenuItem({ className, danger, ...props }, ref) {
  return (
    <RM.Item
      ref={ref}
      className={cn(
        'flex cursor-pointer items-center gap-2.5 rounded-[6px] px-2.5 py-2 font-ui text-sm outline-none data-[highlighted]:bg-surface-2',
        danger ? 'text-error-ink' : 'text-fg',
        className,
      )}
      {...props}
    />
  );
});

export function MenuSeparator() {
  return <RM.Separator className="my-1.5 h-px bg-line" />;
}
